<template>
  <div>
    <div class="clearfix" style="position: relative">
      <img
        class="img_index"
        :src="application.titlePicture"
        :width="imgwidth + 'px'"
        :height="imgHeight + 'px'"
      />
      <div class="h_title0">
        <h1 class="h_title">{{ application.title }}</h1>
      </div>
    </div>

    <div class="margin_top" style="margin-top: 100px">
      <el-row>
        <el-col
          :span="12"
          v-for="(item, index) in application.applicationList"
          :key="index"
          :style="
            index % 2 === 0
              ? 'padding-right: 20px; margin-top: -150px;'
              : 'padding-left: 20px;'
          "
        >
          <h2 style="margin-top: 100px">{{ item.title }}</h2>
          <el-image :src="item.picture" style="width: 100%; height: 300px" />
          <div style="float: left; text-align: left; margin-top: 20px">
            {{ item.content }}
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Application",
  data() {
    return {
      application: global.application,
      imgHeight: 525,
      imgwidth: 0,
    };
  },
  created() {
    // 监听窗口大小变化事件
    window.addEventListener("resize", this.handleResize);
    this.imgwidth = window.innerWidth;
    this.handleResize();
  },
  destroyed() {
    // 移除窗口大小变化事件监听器
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    this.imgwidth = window.innerWidth;
  },
  methods: {
    // 窗口大小变化时更新页面宽度值
    handleResize() {
      this.imgHeight = window.innerWidth / 3;
      this.imgwidth = window.innerWidth;
    },
  },
};
</script>

<style scoped>
.clearfix :before,
.clearfix:after {
  content: "";
  display: table;
}

.clearfix:after {
  clear: both;
}

.clearfix {
  *zoom: 1;
}
.h_title0 {
  position: absolute;
  top: 80%;
  left: 65%;
  transform: translate(-50%, -50%);
  /* text-align: center; */
  /* 让文字居中 */
}
.h_title {
  background-color: #ff5733;
  color: #e5e5e5;
  padding: 2px 15px 5px;
  width: 600px;
  font-size: 30px;
}
.img_index {
  position: relative;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/views/application/application.vue